import { useContext, useEffect, useState } from "react"
import OfferBox from "../../Components/OfferBox/OfferBox"
import { Configuration, ConfiguratorContext } from "../../Contexts/Configuration"
import Offer from "../../Models/Offer"
import API from "../../Services/API"
import { NavigationNode } from "../../Services/Navigation"
import ViewType from "../../Types/ViewType"
import "./OffersView.css"

const OffersView = () => {
	let context = useContext(ConfiguratorContext)

	let [offers, setOffers] = useState<Offer[]>([])
	let [selectedOffer, setSelectedOffer] = useState<Offer | undefined>(context.selectedOffer)

	useEffect(() => {
		(async () => {
			let res = await API.getOffersAsync(context.isHomeUse ? 1 : 2, context.isCovered)
			if (res.success) {
				setOffers(res.data)
			}
		})()
		return () => { };
	}, [context.isHomeUse])

	context.validateOffers = () => {
		context.offerChanged = context.selectedOffer?.id != selectedOffer?.id
		context.selectedOffer = selectedOffer
		let validSelection = selectedOffer !== undefined

		return validSelection;
	}

	return (
		<div className="offers-view-container">
			<div className="configurator-offers-view-title">Seleziona l'offerta che fa per te</div>
			<div className="offers-view-grid">
				{offers.map(x => <OfferBox key={x.id} onSelected={() => setSelectedOffer(x)} selected={selectedOffer?.id === x.id} data={x} />)}
			</div>
		</div>
	)
}

const OffersNode: NavigationNode = {
	content: () => <OffersView />,
	next: (context: Configuration) => ViewType.optionsView,
	previous: (context: Configuration) => ViewType.secondDataPage,
	percentage: 63
}

export default OffersNode
